import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Row } from "react-flexbox-grid/lib/index";
import { Button } from "@material-ui/core/";
import cookies from "browser-cookies";
import ErrorModal from "components/ErrorModal";
import { logInUser, logOutUser } from "../features/auth/actions";
import { store } from "../app/store";

function parseJwt(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(c => {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

// Safari and IE not suported
const isBrowserSuported = () => {
  // ua string for Chrome has 'Safari' in it
  const ua = navigator.userAgent.toLowerCase();

  if (ua.includes("safari")) return ua.includes("chrome");

  if (ua.includes("msie")) return false;

  return true;
};
const RequireLogin = props => {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    const authHeaders = cookies.get("authHeaders");
    const cookieObj = authHeaders && JSON.parse(authHeaders);
    if (cookieObj && cookieObj["access-token"]) {
      store.dispatch(logInUser(parseJwt(cookieObj["access-token"])));
      setTimeout(
        () => store.dispatch(logOutUser()),
        cookieObj["expires-in"] * 1000
      );
    } else {
      store.dispatch(logOutUser());
    }
  }, [document.cookie]);

  if (props.loggedIn && props.allowedAccess) return <div>{props.children}</div>;

  return (
    <div>
      <Row center="xs">
        {!isBrowserSuported() && (
          <p>
            Warning: You are using an unsupported browser. For best results, use{" "}
            <a href="https://www.google.ca/chrome/">Chrome</a> or{" "}
            <a href="https://www.mozilla.org/en-US/firefox/">Firefox</a>.
          </p>
        )}
      </Row>
      <Row center="xs">
        <Button variant="contained" href={`${process.env.API_URL}/auth/client`}>
          Please log in to continue
        </Button>
      </Row>
      {!props.allowedAccess && props.userEmail && (
        <ErrorModal
          errorModalOpen={isOpen}
          type="Restricted"
          errorMessage={`Access to this site for ${props.userEmail} is restricted. Are you using the correct email address? If so, please request access from the eims support team.`}
          onErrorModalClose={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

RequireLogin.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  allowedAccess: PropTypes.bool.isRequired,
  userEmail: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  actions: PropTypes.shape({
    checkDevMode: PropTypes.func.isRequired
  }).isRequired
};

RequireLogin.defaultProps = {
  userEmail: ""
};

export default RequireLogin;
